export const DDQr = '//img.alicdn.com/imgextra/i3/O1CN01xGbzSu1Hojbzx4t1I_!!6000000000805-2-tps-211-211.png'
export const WXQr = '//img.alicdn.com/imgextra/i3/O1CN01NGew031Js3iUvXUMT_!!6000000001083-2-tps-445-446.png'
